// (function() {
//     'use strict';

//     // Global variables
//     var squiz = {
//         'fn': {},
//         'vars': {}
//     };

//     // Functions
//     squiz.fn.sampleFunction = function() {

//     };

//     // Make squiz variable available to the console for debugging
//     window.squiz = squiz;
// }());

import { FUNNELBACK_SEARCH } from './_constants';

(function() {
    "use strict";
    const AUTOCOMPLETE_INPUT_ACTIVE = 'main-search__input--active';

    const autocompleteInput = $(".search__input");
    const searchUrl = autocompleteInput.closest('form').data('searchUrl');
    let searchOpen = false;
    if (autocompleteInput) {
        const searchToggle = $(".search-toggle");
        searchToggle.on('click', () => {
            searchOpen = !searchOpen;
            searchToggle.each((bi, button) => {
                // console.log(button)
                $(button).attr('aria-expanded', function() {
                    return searchOpen
                });
            });
            $('#main-search').toggleClass('show');
            if (searchOpen) {
                $('#main-search').attr('tabindex', '0');
                $('.main-search__input').focus();
            } else {
                $('#main-search').attr('tabindex', '-1');
            }
        })
        autocompleteInput.autocompletion({
            datasets: {
                organic: {
                    name: "Suggestions",
                    collection: "student-pathways-meta",
                    profile: "_default",
                    program: FUNNELBACK_SEARCH,
                },
                jobs: {
                    /* 
                    Jobs is backed by a PUSH collection, as documents can be added and removed in real time
                    a CSV backed autocompletion isnt feasible; instead the standard search json endpoint is used. 

                    A Groovy script on Funnelback converts any query entered into a wildcard search to act more
                    like a suggestion / concierge query does.
                */
                    name: "Related work opportunities",
                    collection: "student-pathways-opportunities",
                    profile: "wildcard-search",
                    program: FUNNELBACK_SEARCH,
                    queryKey: "query",
                    transform: function(queryPayload, response, param) {
                        /*
                        The 'program' endpoint is -supposed- to return an array. But search.json returns an object; 
                        Since arrays are just object which use numbers as their keys this still works as there is no specific
                        array type checking in the autocompletion code.

                        This function is called for each key/property but we only want to process the "response" property of the
                        search.json response as that has the results data in it.
                    */

                        if (param === "response") {
                            const results = response.resultPacket.results;
                            let autoCompplete = [];

                            results.forEach((result) => {
                                autoCompplete.push({
                                    label: result.title,
                                    value: `Visit: ${result.metaData.jobTitle}`,
                                    extra: {
                                        action: `${searchUrl}?jobId=${result.metaData.assetid}`,
                                        action_t: "U",
                                    },
                                    custom: result,
                                    rank: result.rank,
                                });
                            });

                            return autoCompplete;
                        }
                    },
                    show: 5,
                    template: {
                        suggestion: `<a href='${searchUrl}?jobId={{custom.metaData.assetid}}' class='home-fip-autocomplete'>
                                <div class='home-fip-autocomplete__top'>{{custom.metaData.jobOrganisation}} / {{custom.metaData.jobLocation}} / Apply by {{custom.metaData.jobDueDateText}}</div>
                                <div class='home-fip-autocomplete_bottom'>{{custom.metaData.jobTitle}}</div>                                
                            </a>`,
                    },
                },
            },
            length: 3,
            typeahead: {
                hint: false,
                events: {
                    open: () => {
                        autocompleteInput.addClass(AUTOCOMPLETE_INPUT_ACTIVE)
                    },

                    close: () => {
                        autocompleteInput.removeClass(AUTOCOMPLETE_INPUT_ACTIVE)
                    },
                },
            },
            scrollable: false,
        });
    }

})();